"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var API_BASE = 'meetings/v1';

var MeetingsAPI =
/*#__PURE__*/
function () {
  function MeetingsAPI() {
    (0, _classCallCheck2.default)(this, MeetingsAPI);
  }

  (0, _createClass2.default)(MeetingsAPI, null, [{
    key: "getMeetingsUser",
    value: function getMeetingsUser() {
      return _apiClient.default.get(API_BASE + "/user?portalId=" + _hubspot.default.get());
    }
  }, {
    key: "createMeetingsUser",
    value: function createMeetingsUser(data) {
      return _apiClient.default.post(API_BASE + "/user?portalId=" + _hubspot.default.get(), {
        data: data
      });
    }
  }, {
    key: "getMeetingsLink",
    value: function getMeetingsLink() {
      return _apiClient.default.get(API_BASE + "/link?portalId=" + _hubspot.default.get());
    }
  }, {
    key: "verifyUser",
    value: function verifyUser() {
      return _apiClient.default.get(API_BASE + "/verify?portalId=" + _hubspot.default.get());
    }
  }, {
    key: "updateMeetingsLink",
    value: function updateMeetingsLink(_ref) {
      var meetingsLink = _ref.meetingsLink,
          meetingsUserId = _ref.meetingsUserId;
      return _apiClient.default.put(API_BASE + "/link/" + encodeURIComponent(meetingsLink.slug) + "?portalId=" + _hubspot.default.get(), {
        data: (0, _extends2.default)({}, meetingsLink, {
          meetingsUserId: meetingsUserId
        })
      });
    }
  }, {
    key: "validateNamespace",
    value: function validateNamespace(namespace) {
      return _apiClient.default.get(API_BASE + "/user/namespace/" + namespace + "/exists?portalId=" + _hubspot.default.get());
    }
  }, {
    key: "disconnectMeetingsUser",
    value: function disconnectMeetingsUser() {
      return _apiClient.default.delete(API_BASE + "/user?portalId=" + _hubspot.default.get());
    }
  }, {
    key: "getEmailProvider",
    value: function getEmailProvider() {
      return _apiClient.default.get('facsimile/v1/provider');
    }
  }, {
    key: "saveMeetingsUser",
    value: function saveMeetingsUser(_ref2) {
      var namespace = _ref2.namespace,
          calendarSettings = _ref2.calendarSettings,
          customHostedDomain = _ref2.customHostedDomain;
      return _apiClient.default.put(API_BASE + "/user?portalId=" + _hubspot.default.get(), {
        data: {
          namespace: namespace,
          customHostedDomain: customHostedDomain,
          meetingsUserBlob: {
            default: null,
            calendarSettings: calendarSettings
          }
        }
      });
    }
  }, {
    key: "getCalendarInfo",
    value: function getCalendarInfo() {
      return _apiClient.default.get(API_BASE + "/calendar/info-list?portalId=" + _hubspot.default.get());
    }
  }, {
    key: "getCustomHostedDomains",
    value: function getCustomHostedDomains() {
      return _apiClient.default.get("content/api/v4/domains/public?portalId=" + _hubspot.default.get() + "&skipdnscheck=true");
    }
  }, {
    key: "getPrimaryCalendar",
    value: function getPrimaryCalendar() {
      return _apiClient.default.get(API_BASE + "/calendar/primary");
    }
  }, {
    key: "verifyCalendars",
    value: function verifyCalendars() {
      return _apiClient.default.get(API_BASE + "/verify/response-summaries");
    }
  }]);
  return MeetingsAPI;
}();

exports.default = MeetingsAPI;
module.exports = exports.default;